import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { LockedTooltipComponent } from './locked-tooltip.component';

@NgModule({
  declarations: [LockedTooltipComponent],
  imports: [CommonModule, ButtonModule],
  exports: [LockedTooltipComponent],
})
export class LockedTooltipModule {}
